import { DefaultState } from './default-state.type';

export const defaultState: DefaultState = {
	showAccessoryDropdown: false,
	selectedAccessory: [],
	removedAccessory: '',
	priceAccessory: [],
	accessoryDescription: [],
	skuAccessory: []
};
